export const isEventSaleOpen = event =>
  !!event && !!event.applicationsOpen && !event.soldOut && !event.canceled

export const getEventSaleStatus = event => {
  if (event.canceled) return 'Canceled'
  if (event.soldOut) return 'Sold out'
  if (!event.applicationsOpen) return 'Sales closed'

  return ''
}
